module.exports = __webpack_public_path__ + "static/media/blackBelt_whiteCoat.2d7fb9da.webp";